<template>
  <div>
    <div class="box">
        <!-- 头部 -->
        <headTail  :banquanType='banquanType' current='活动'></headTail>
        <!-- 头部结束 -->
        <!-- 图片开始 -->
        <div class="imge-box"> 
           <img class="imge-box-img" src="../image/huod.gif">
        </div>
        <!-- 图片结束 -->
        <!-- 主体 -->
        <div class="bj">
             <div class="loi" style="font-size: 38px;width:160px" ref="lightBtn">活动资讯</div>
                <!-- 新闻内容开始 -->
            <div class="new-body"  v-for="(item,index) in lists" :key="index"> 
              
              <div class="new-body2">
                <div class="shijie">
                  <div class="shijie3" style="font-size: 24px; width:200px;">
                       {{item.activityTime.slice(5, 10)}}
                  </div>
                  <div class="shijie2" style="font-size: 14px;">
                       {{item.activityTime.slice(0, 4)}}
                  </div>
                  
              </div>
                <div class="kio">
                  <div class="nuyt">
                    <div class="news-biao" @click="tiao(item.id)" style="font-size: 22px;">
                     {{item.title}}
                    </div>
                     <div class="news-biao2" style="">
                       <!-- {{item.activityTime}} -->
                    </div>
                    <div class="news-biao3" style="font-size: 17px;line-height: 30px;">
                      <!-- <div class="news-biao3"> -->
                     <!-- {{item.content | filtersText}} -->
                     {{ToText(item.content)}}
                    </div>
                  </div>
                    <img class="box-img22" :src="imges+item.coverPic" >
                </div>
              </div>
                <div class="introduce-box-hen11" style=" width: 275px;
height: 1px;"></div>
                <div class="introduce-box-hen12" ></div>
                <div class="introduce-box-hen13" style="left: 180px;
 width: 1px;height: 100px;"></div>
          <div v-show="index==0" class="introduce-box-hen14" style="left: 180px;
        width: 1px;height: 135px;"></div>
          </div>
              <div class="block">
                <el-pagination    
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage4"
                  :page-sizes="[pdlist.pageSize]"
                  :page-size="pdlist.pageSize"
                  layout="total, prev, pager, next"
                  :total="total">
                </el-pagination>
              </div>
    </div>
              
                <headBar></headBar>
        <!-- 图片结束 -->
                <!-- <div class="introduce-box">
                    <img class="body-box-imgs" src="../image/icon3.png">
                    <h2 class="loi" style="margin-top:10px">合作品牌</h2>
                    <img class="body-box-imgs" src="../image/icon3.png">
                </div> -->
        </div>
        <!-- 主体结束 -->
      
    </div>
  </div>
</template>
<script>
import * as config from "@/util/berurl.js";
export default {
   
  name: 'activity',
  data () {
    return {
      lists:[],
      imges:config.baseImage,
      total:null,
      api:config.basePath,
      currentPage4: 4,
      banquanType:1,
      pdlist:{
        pageNum: 1,
        pageSize: 10,
        column: 10001,
        targetId:234
      },
      msg: 'Welcome to Your Vue.js App'
    }
  },
   filters: {
    
    filtersText(val) { 
       let solution = '';
   if (val) {
    var reg = /[\u4e00-\u9fa5]/g
    var names = val.match(reg)
    if(names) {
       solution = names.join('')
      console.log('文字',val)
    }
   
      // return val.substr(0, 50);//获取富文本文字内容的前50个字符
  } else{
    solution = ''
  }
  return solution
    },
  },
   mounted(){
    this.list()
  },
   methods:{
       ToText(HTML)
    {
      var input = HTML;
      return input.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi,'').replace(/<[^>]+?>/g,'').replace(/\s+/g,' ').replace(/ /g,' ').replace(/>/g,' ').replace(/&ldquo;/g,' ').replace(/&rdquo;/g,' ').replace(/&mdash;/g,' ').replace(/&nbsp;/g,' ').replace(/&middot;/g,' ');  
    },

    tiao(id) {
      this.$router.push({
            path: '/activityDetails',
            query: {
                id: id
            }
        })
    },
    list() {
      
       this.$axios({
                method:'GET',
                url: this.api+'api-cms/notAuth/cmsOfflineNews/list/',
               params:{'pageNum': this.pdlist.pageNum, 
                    'pageSize':  this.pdlist.pageSize,
                    'column':  this.pdlist.column,
                    'targetId':this.pdlist.targetId
               }
            }).then((res) =>{    
              if(res.data.code==200) {
                  
                this.total = res.data.data.total 
                this.lists = res.data.data.records
                 console.log('数据',this.lists) 
                //  console.log('数据3',res.data.data.total)   
              }   
               
            })
    },
       handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.pdlist.pageNum = val
        this.list()
      }
  }
}
</script>
<style >
.el-pagination__jump{
  font-size: 30px !important;
}
.el-pagination__total{
  font-size: 30px !important;
}
.el-pager li {
  font-size:30px !important;
  color: #666666 !important;
font-weight: 400 !important;
}
.el-pager li.active{
  color: #409EFF !important;
}
.el-pagination__sizes .el-input .el-input__inner{
   font-size:30px !important;
}
.el-select-dropdown__item{
   font-size:30px !important;
}
.el-pagination .el-select .el-input .el-input__inner{
  width: 150px !important;
}
.el-pagination .el-input__inner{
font-size:30px !important;
}
</style>
<style scoped>
.kio{
  /* background: yellow; */
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.block{
  margin-top: 56px;
  display: flex;
    justify-content: center;
}
.introduce-box-hen1{
  position: absolute;
  top: 82px;
  left: 0px;
  width: 352px;
height: 1px;
border-top: 1px solid  #C09255;
/* background: #C09255; */
}
.introduce-box-hen11{
  position: absolute;
  top: -43px;
  left: 0px;
  width: 352px;
height: 1px;
border-top: 1px solid  #C09255;
/* background: #C09255; */
}
.introduce-box-hen2{
  position: absolute;
  top: 82px;
  left: 352px;
 width: 904px;
height: 1px;
border-top: 1px solid #BFBFBF;
/* background: #BFBFBF; */
}
.introduce-box-hen12{
  position: absolute;
  top: -43px;
  left: 275px;
 width: 980px;
height: 1px;
border-top: 1px solid #BFBFBF;
/* background: #BFBFBF; */
}
.introduce-box-hen3{
  position: absolute;
  top: 26px;
  left: 284px;
 width: 1px;
height: 420px;
border-right: 1px solid #BFBFBF;
/* background: #BFBFBF; */
}
.introduce-box-hen13{
  position: absolute;
  top: -43px;
  left: 284px;
 width: 1px;
height: 420px;
border-right: 1px solid #BFBFBF;
/* background: #BFBFBF; */
}
.introduce-box-hen14{
  position: absolute;
  top: -135px;
  left: 284px;
 width: 1px;
height: 420px;
border-right: 1px solid #BFBFBF;
/* background: #BFBFBF; */
}
.shijie{

}
.shijie2{
/* width: 54px; */
height: 17px;
font-size: 24px;
font-family: FZXiaoBiaoSong-B05S;
font-weight: 400;
color: #333333;
text-align: left;
margin-left: 5px

}
.shijie3{
  width: 182px;
height: 25px;
font-size: 36px;
font-family: FZXiaoBiaoSong-B05S;
font-weight: 400;
color: #C09255;
margin-bottom: 37px;
text-align: left;
}
.bj{
   background: url(../image/huod2.png) no-repeat ;
  background-size:100% 100%;
  /* height: 1400px; */
  background-size: cover;
  padding-left: 334px;
  padding-right: 332px;
  padding-bottom: 69px;
}
.news-biao3{
  color: #666666;
  font-size: 24px;
  overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    
}
.news-biao{
  color: #333333;
  font-size: 32px;
      overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    /* background: yellow; */
    /* width: 650px; */
}
.news-biao:hover{
color: #c79f62;
}
.news-biao2{
  font-size: 24px;
  /* margin-bottom: 69px; */
  margin-top: 32px;
  font-weight: 400;
color: #333333;

}
.new-hen{
  margin-top: 48px;
  width: 1256px;
  border-top: 10px solid #F6F6F6;
  margin-bottom: 48px;
}
.nuyt{
  text-align: left;
  /* margin-left: 30px; */
}
.box-img22 {
  width: 370px;
  height: 230px;
  margin-left: 38px;
  /* min-width: 370px;
  max-width: 402px;
  max-height: 402px;
  min-height: 402px; */
}
.new-body2{
  display: flex;
  /* height: 327px; */
  /* background: yellow; */
  padding-bottom: 71px;
}
.new-body{
  position: relative;
   /* padding-left: 332px;
   padding-right: 332px; */
   /* background: yellow; */
   /* display: flex; */
   /* justify-content: space-between; */
}
.dui-box1{
   display: flex;
  align-items: center;
  width: 40%;
  margin: auto;
 justify-content: space-between;
 margin-bottom: 71px;
 flex-flow: wrap;
}
h2{
  margin-top: 40px !important;
}
.loi{
  width: 350px;
  font-size: 60px;
  font-weight: 400;
color: #333333;
padding-top: 61px;
margin-bottom: 87px;
}
.introduce-box{
  display: flex;
  justify-content: space-between;
  margin: auto;
  /* background: red; */
  align-items: center;
 /* max-width: 470px; */
  margin-top: 79px;
  padding-left: 652px;
  padding-right: 610px;
}
.body-box-imgs{
  width: 189px;
  height: 78px;
}
.zhu-img{
  width: 1256px;
  height: 608px;
  margin: auto;
  margin-bottom: 56px;
}
.huod{
  width: 580px;
  height: 176px;
  position: relative;
  margin: auto;
  margin-bottom: 76px;
}
.imge-box-imgs{
  height: 100%;
  width: 100%;
}
.imge-box-imgs2{
  height: 129px;
  width: 91px;
  position: absolute;
  left: 5%;
    top: 24%;
}
.sheji-wen{
  color: #333333;
  font-size: 60px;
   position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) 
}
.imge-box-img{
  width: 100%;
  height: 100%;
}
.imge-box {
  width: 1920px;
  height: 368px;
}
/* 首页 */
.box{
  width: 1920px;
 
}
.thehead-box{
 height: 120px;
  /* background: #FFFFFF; */
  background: yellow;
}
.thehead-box2{
  flex: 1;
  display: flex;
  justify-content: space-between;
  height: 100%;
  align-items: center;
}
.thehead{
  width: 70%;
  margin: auto;
  /* background: yellow; */
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
}
.img-box{
  width: 50%;
  /* background: red; */
  text-align: initial;
}
.imge{
  width: 135px;
  height: 80px;
}
.thehead-fengt{
  /* color: #FFFFFF; */
  font-size: 30px;
}
/* 首页结束 */
</style>


// WEBPACK FOOTER //
// src/components/activity.vue